import { Helmet } from "react-helmet-async";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

function Contact() {
  const [companyLanguage, setCompanyLanguage] = useState(() => {
    return localStorage.getItem("companyLanguage") || 'en';
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    option: (localStorage.getItem("companyLanguage") || 'en') === 'ur' ? "کاروباری حکمت عملی" : "Business Strategy",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  useEffect(() => {
    const lang = localStorage.getItem("companyLanguage") || 'en';
    setCompanyLanguage(lang);
    
    const handleStorageChange = () => {
      const updatedLang = localStorage.getItem("companyLanguage") || 'en';
      setCompanyLanguage(updatedLang);
    };
    
    window.addEventListener('companyDataUpdated', handleStorageChange);
    
    const interval = setInterval(() => {
      const updatedLang = localStorage.getItem("companyLanguage") || 'en';
      if (updatedLang !== companyLanguage) {
        setCompanyLanguage(updatedLang);
      }
    }, 2000);

    return () => {
      window.removeEventListener('companyDataUpdated', handleStorageChange);
      clearInterval(interval);
    };
  }, [companyLanguage]);

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success(companyLanguage === 'ur' ? "پیغام کامیابی سے بھیج دیا گیا! ہم جلد آپ سے رابطہ کریں گے۔" : "Message sent successfully! We'll get back to you soon.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      option: companyLanguage === 'ur' ? "کاروباری حکمت عملی" : "Business Strategy",
      message: ""
    });
  };

  const isUrdu = companyLanguage === 'ur';

  return (
    <>
      <Helmet><title>Contact Us - Bexon Business Solutions</title></Helmet>
      
      {/* Hero Section */}
      <section className={`bg-gradient-to-br from-indigo-900 via-purple-900 to-indigo-800 text-white py-20 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}} dir={isUrdu ? 'rtl' : 'ltr'}>
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">
            {companyLanguage === 'ur' ? 'رابطہ کریں' : 'Get in Touch'}
          </h1>
          <p className="text-xl text-gray-300">
            {companyLanguage === 'ur' ? 'ہمیں لکھیں - ہم آپ سے سننا پسند کریں گے' : "Drop Us a Line - We'd love to hear from you"}
          </p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className={`py-20 bg-white ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}} dir={isUrdu ? 'rtl' : 'ltr'}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">
              {companyLanguage === 'ur' ? 'ہمیں لکھیں۔' : 'Drop Us a Line.'}
            </h2>
            <form onSubmit={handleSubmit} className="bg-gray-50 p-8 rounded-lg">
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className={`block text-gray-700 font-semibold mb-2 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}>
                    {companyLanguage === 'ur' ? 'نام *' : 'Name *'}
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    placeholder={companyLanguage === 'ur' ? 'آپ کا نام' : "Your Name"}
                  />
                </div>
                <div>
                  <label className={`block text-gray-700 font-semibold mb-2 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}>
                    {companyLanguage === 'ur' ? 'ای میل *' : 'Email *'}
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className={`block text-gray-700 font-semibold mb-2 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}>
                    {companyLanguage === 'ur' ? 'فون' : 'Phone'}
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    placeholder="+1 (234) 567-8900"
                  />
                </div>
                <div>
                  <label className={`block text-gray-700 font-semibold mb-2 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}>
                    {companyLanguage === 'ur' ? 'ایک آپشن منتخب کریں *' : 'Choose an Option *'}
                  </label>
                  <select
                    name="option"
                    value={formData.option}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  >
                    {companyLanguage === 'ur' ? (
                      <>
                        <option>کاروباری حکمت عملی</option>
                        <option>کسٹمر تجربہ</option>
                        <option>پائیداری اور ESG</option>
                        <option>تربیت اور ترقی</option>
                        <option>آئی ٹی سپورٹ اور دیکھ بھال</option>
                        <option>مارکیٹنگ حکمت عملی</option>
                      </>
                    ) : (
                      <>
                        <option>Business Strategy</option>
                        <option>Customer Experience</option>
                        <option>Sustainability and ESG</option>
                        <option>Training and Development</option>
                        <option>IT Support & Maintenance</option>
                        <option>Marketing Strategy</option>
                      </>
                    )}
                  </select>
                </div>
              </div>
              <div className="mb-6">
                <label className={`block text-gray-700 font-semibold mb-2 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}>
                  {companyLanguage === 'ur' ? 'پیغام *' : 'Message *'}
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600"
                  placeholder={companyLanguage === 'ur' ? 'ہمیں اپنے منصوبے یا استفسار کے بارے میں بتائیں...' : "Tell us about your project or inquiry..."}
                />
              </div>
              <button
                type="submit"
                className={`w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-8 py-3 rounded-lg transition ${isUrdu ? 'font-urdu' : ''}`}
                style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}}
              >
                {companyLanguage === 'ur' ? 'پیغام بھیجیں' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Office Locations */}
      <section className={`py-20 bg-gray-50 ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}} dir={isUrdu ? 'rtl' : 'ltr'}>
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">
            {companyLanguage === 'ur' ? 'ہمارے دفاتر' : 'Our Offices'}
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {companyLanguage === 'ur' ? 'ہیڈ آفس' : 'Head Office'}
              </h3>
              <p className="text-gray-600 mb-4">
                Islamabad, Pakistan
              </p>
              <p className="text-gray-600 mb-2">
                <strong>{companyLanguage === 'ur' ? 'فون:' : 'P:'}</strong> <a href="tel:03231099709" className="hover:text-indigo-600">03231099709</a>
              </p>
              <p className="text-gray-600">
                <strong>{companyLanguage === 'ur' ? 'ای میل:' : 'M:'}</strong> <a href="mailto:choudharyusama908@gmail.com" className="hover:text-indigo-600">choudharyusama908@gmail.com</a>
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {companyLanguage === 'ur' ? 'علاقائی دفتر' : 'Regional Office'}
              </h3>
              <p className="text-gray-600 mb-4">
                Islamabad, Pakistan
              </p>
              <p className="text-gray-600 mb-2">
                <strong>{companyLanguage === 'ur' ? 'فون:' : 'P:'}</strong> <a href="tel:03231099709" className="hover:text-indigo-600">03231099709</a>
              </p>
              <p className="text-gray-600">
                <strong>{companyLanguage === 'ur' ? 'ای میل:' : 'M:'}</strong> <a href="mailto:choudharyusama908@gmail.com" className="hover:text-indigo-600">choudharyusama908@gmail.com</a>
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {companyLanguage === 'ur' ? 'علاقائی دفتر' : 'Regional Office'}
              </h3>
              <p className="text-gray-600 mb-4">
                Islamabad, Pakistan
              </p>
              <p className="text-gray-600 mb-2">
                <strong>{companyLanguage === 'ur' ? 'فون:' : 'P:'}</strong> <a href="tel:03231099709" className="hover:text-indigo-600">03231099709</a>
              </p>
              <p className="text-gray-600">
                <strong>{companyLanguage === 'ur' ? 'ای میل:' : 'M:'}</strong> <a href="mailto:choudharyusama908@gmail.com" className="hover:text-indigo-600">choudharyusama908@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact */}
      <section className={`py-20 bg-indigo-600 text-white ${isUrdu ? 'font-urdu' : ''}`} style={isUrdu ? { fontFamily: "'Noto Nastaliq Urdu', 'Jameel Noori Nastaleeq', 'Al Qalam Taj Nastaleeq', serif" } : {}} dir={isUrdu ? 'rtl' : 'ltr'}>
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">
            {companyLanguage === 'ur' ? 'فوری مدد چاہیے؟' : 'Need Immediate Assistance?'}
          </h2>
          <p className="text-xl text-gray-200 mb-8">
            {companyLanguage === 'ur' ? 'مفت مشاورت کے لیے ابھی کال کریں' : 'Call us now for a free consultation'}
          </p>
          <a href="tel:03231099709" className="text-3xl font-bold text-yellow-400 hover:text-yellow-300">
            03231099709
          </a>
        </div>
      </section>
    </>
  );
}

export default Contact;

